import React from 'react'
import { Field, FieldArray, reduxForm } from 'redux-form'
import Moment from "moment";
import { Button, Table } from 'react-bootstrap';

const required = value => value ? undefined : 'Required'
const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined

const renderField = ({ input, label, type, meta: { touched, error } }) => (
    <div>
      <input {...input} type={type} placeholder={label} style={{width: '100%'}} />
      {touched && error && <span>{error}</span>}
    </div>
)

const DemoUserForm = props => {
	const { handleSubmit, submitting, reset, pristine, initialValues} = props
	return (
     <form onSubmit={handleSubmit}>
       <Table striped bordered hover size="lg">
        <thead>
          <tr>
            <th>Company ID</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{background: '#00800038'}}>
            <td>
              <Field
                name={`id`}
                type="number"
                component={renderField}
                label={`Company ID`}
                validate={[ required, number ]}
              />
            </td>
          </tr>
        </tbody>
        </Table>
        <div className="p-1">
          <button type="submit" className="btn btn-success btn-sm mr-2" disabled={submitting}>
          disable download
          </button>
          <button type="button" className="btn btn-primary btn-sm" disabled={pristine || submitting} onClick={reset}>
            Undo Values
          </button>
        </div>
    </form>
  )
}

export default reduxForm({
  form: 'DemoUserForm', // a unique identifier for this form
  enableReinitialize: true
})(DemoUserForm)


// WEBPACK FOOTER //
// ./src/components/Insights/DemoUserForm.js